<mat-checkbox
	color="primary"
	[ngClass]="{ 'has-error': _hasError }"
	[(ngModel)]="checkBoxValue"
	(change)="onValueChanges(checkBoxValue)"
></mat-checkbox>
<ng-content></ng-content>
